import moment from 'moment';

export const candidateSortOptions = {
  previouslyRated: 'previously-rated',
  skillsMatch: 'skills-match',
  localFavorites: 'local-favorites',
};

export const candidateSortEventMapping = {
  [candidateSortOptions.previouslyRated]: 'Confirm Candidate - Sort By Previously Rated Submitted',
  [candidateSortOptions.skillsMatch]: 'Confirm Candidate - Sort By Skill Match Submitted',
  [candidateSortOptions.localFavorites]: 'Confirm Candidate - Sort By Local Favorites Submitted',
};

export const defaultFilters = {
  sort: candidateSortOptions.localFavorites,
  page: 1,
  totalPages: 1,
  limit: 5,
};

export const formatExperienceDates = (
  startDate: string,
  endDate: string | null | undefined,
  isCurrentEmployer: boolean,
): string => {
  const formattedStart = moment(startDate).format('MMMM DD, YYYY');

  if (isCurrentEmployer) {
    return `${formattedStart} / Present`;
  }

  if (endDate) {
    const formattedEnd = moment(endDate).format('MMMM DD, YYYY');
    return `${formattedStart} / ${formattedEnd}`;
  }

  return formattedStart;
};

export const formatGraduationDate = (graduationDate: string | null | undefined): string => {
  if (!graduationDate) {
    return '-';
  }

  return moment(graduationDate).format('MMMM DD, YYYY');
};
